import React from 'react';
import { EventRegistration } from 'resources';

class UnauthenticatedRegistrationConfirmation extends React.Component {

  state = {
    eventRegistration: {},
  }

  componentDidMount() {
    this.doObjectRetrieve();
  }

  objectQuery = `
    event_registration {
      event {
        name
      }
    }
  `
  doObjectRetrieve = () => {
    EventRegistration.retrievePublic({
      id: this.props.params.registration_id,
      query: this.objectQuery,
      onSuccess: ({ data }) => this.setState({
        eventRegistration: data,
      }),
    });
  }

  render = () => {
    const { eventRegistration } = this.state;

    if (!eventRegistration) {
      return null;
    }

    return (
      <div className="account-wrapper">
        <p className="account-wrapper m-t-2 m-b-neg-1"><br /></p>
        <div className="account-body m-t-2">
          <h3 className="text-success m-b-05">Thanks for your submission!</h3>
          <h5 className="m-b-1">{_.get(eventRegistration, 'event.name')}</h5>
        </div>
      </div>
    );
  }

}

export default UnauthenticatedRegistrationConfirmation;
